// #region Imports
import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import "react-datepicker/dist/react-datepicker.css"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import InputMask from "react-input-mask"

import {
  Badge,
  Col,
  Row,
  Label,
  Form,
  Input,
  InputGroup,
  FormFeedback,
  UncontrolledAlert,
  UncontrolledTooltip,
} from "reactstrap"
import DropzoneComponent from "../../components/Common/DropzoneComponent"
import ImageCropComponent from "../../components/Common/ImageCropComponent"
import ImageWithFallback from "../../components/Common/ImageWithFallback"
import Webcam from "../../components/Common/WebcamComponent"
import { useFormik } from "formik"
import * as Yup from "yup"
import avatar9 from "../../assets/images/users/avatar-9.jpg"
import { Link } from "react-router-dom"
// #endregion

// #region selectors
import {
  useControlEscolarIsLoadingoPersona,
  useAuthPermiso,
  useControlEscolarError,
  useControlEscolaroNotificacion,
  useAuthIdPersonaAuthenticated,
  useControlEscolaroPhotoCredencial,
  useControlEscolarEmail,
  useControlEscolarIsLoadingEmail,
  useControlEscolarCurp,
  useControlEscolarIsLoadingCurp,
} from "store/selectors"
// #endregion

// #region actions
import {
  getControlEscolarGetPersona as onGetControlEscolarGetPersona,
  putControlEscolarPutPersona as onPutControlEscolarPutPersona,
  ControlEscolarUnsetError,
  ControlEscolarUnsetNotificacion,
  postControlEscolarSendPassword as onPostControlEscolarSendPassword,
  postControlEscolarUploadPhoto,
  getControlEscolarGetEmail,
  getControlEscolarGetCurp,
} from "../../store/actions"
import { use } from "react"
// #endregion

const AltaGenerales = ({
  formik,
  handleUpperCaseChange,
  handleLowerCaseChange,
  idAlumno,
  oPersona,
  isEdit,
}) => {
  //
  // #region Init

  const optionsFlatpickr = {
    locale: Spanish,
    altInput: true,
    dateFormat: "Y-m-d",
    enableTime: false,
  }
  // #endregion

  // #region const-selectors
  const isAdministradorGeneral = useAuthPermiso(["sis_administrador_general"])
  const notificacion = useControlEscolaroNotificacion()
  const error = useControlEscolarError()
  const idPersonaAuthenticated = useAuthIdPersonaAuthenticated()
  const oPhotoCredencial = useControlEscolaroPhotoCredencial()
  const isLoading = useControlEscolarIsLoadingoPersona()
  const email = useControlEscolarEmail()
  const isLoadingEmail = useControlEscolarIsLoadingEmail()
  const curp = useControlEscolarCurp()
  const isLoadingCurp = useControlEscolarIsLoadingCurp()
  // #endregion selectors

  // #region useRef
  const flatpickrRef = useRef(null)
  // #endregion

  // #region Options
  const estadosOptions = [
    { value: 1, label: "Aguascalientes" },
    { value: 2, label: "Baja California" },
    { value: 3, label: "Baja California Sur" },
    { value: 4, label: "Campeche" },
    { value: 5, label: "Chiapas" },
    { value: 6, label: "Chihuahua" },
    { value: 7, label: "Coahuila" },
    { value: 8, label: "Colima" },
    { value: 9, label: "Distrito Federal" },
    { value: 10, label: "Durango" },
    { value: 11, label: "Guerrero" },
    { value: 12, label: "Guanajuato" },
    { value: 13, label: "Hidalgo" },
    { value: 14, label: "Jalisco" },
    { value: 15, label: "México" },
    { value: 16, label: "Michoacán" },
    { value: 17, label: "Morelos" },
    { value: 18, label: "Nayarit" },
    { value: 19, label: "Nuevo León" },
    { value: 20, label: "Oaxaca" },
    { value: 21, label: "Puebla" },
    { value: 22, label: "Querétaro" },
    { value: 23, label: "Quintana Roo" },
    { value: 24, label: "San Luis Potosí" },
    { value: 25, label: "Sinaloa" },
    { value: 26, label: "Sonora" },
    { value: 27, label: "Tabasco" },
    { value: 28, label: "Tamaulipas" },
    { value: 29, label: "Tlaxcala" },
    { value: 30, label: "Veracruz" },
    { value: 31, label: "Yucatán" },
    { value: 32, label: "Zacatecas" },
    { value: 33, label: "Otro" },
  ]

  const paisesOptions = [
    { value: 1, label: "Afganistán" },
    { value: 2, label: "Albania" },
    { value: 3, label: "Alemania" },
    { value: 4, label: "Andorra" },
    { value: 5, label: "Angola" },
    { value: 6, label: "Antigua y Barbuda" },
    { value: 7, label: "Arabia Saudita" },
    { value: 8, label: "Argelia" },
    { value: 9, label: "Argentina" },
    { value: 10, label: "Armenia" },
    { value: 11, label: "Australia" },
    { value: 12, label: "Austria" },
    { value: 13, label: "Azerbaiyán" },
    { value: 14, label: "Bahamas" },
    { value: 15, label: "Bahrein" },
    { value: 16, label: "Bangladesh" },
    { value: 17, label: "Barbados" },
    { value: 18, label: "Bielorrusia" },
    { value: 19, label: "Bélgica" },
    { value: 20, label: "Belice" },
    { value: 21, label: "Benín" },
    { value: 22, label: "Bhután" },
    { value: 23, label: "Bolivia" },
    { value: 24, label: "Bosnia y Herzegovina" },
    { value: 25, label: "Botswana" },
    { value: 26, label: "Brasil" },
    { value: 27, label: "Brunei Darussalam" },
    { value: 28, label: "Bulgaria" },
    { value: 29, label: "Burkina Faso" },
    { value: 30, label: "Burundi" },
    { value: 31, label: "Cabo Verde" },
    { value: 32, label: "Camboya" },
    { value: 33, label: "Camerún" },
    { value: 34, label: "Canadá" },
    { value: 35, label: "Chad" },
    { value: 36, label: "Chile" },
    { value: 37, label: "China" },
    { value: 38, label: "Chipre" },
    { value: 39, label: "Colombia" },
    { value: 40, label: "Comoras" },
    { value: 41, label: "Congo" },
    { value: 42, label: "Costa Rica" },
    { value: 43, label: "Côte d Ivoire" },
    { value: 44, label: "Croacia" },
    { value: 45, label: "Cuba" },
    { value: 46, label: "Dinamarca" },
    { value: 47, label: "Dominica" },
    { value: 48, label: "Ecuador" },
    { value: 49, label: "Egipto6" },
    { value: 50, label: "El Salvador" },
    { value: 51, label: "Emiratos Árabes Unidos" },
    { value: 52, label: "Eritrea" },
    { value: 53, label: "Eslovaquia" },
    { value: 54, label: "Eslovenia" },
    { value: 55, label: "España" },
    { value: 56, label: "Estados Unidos de América" },
    { value: 57, label: "Estonia" },
    { value: 58, label: "Etiopía" },
    { value: 59, label: "ex República Yugoslava de Macedonia" },
    { value: 60, label: "Federación Rusa" },
    { value: 61, label: "Fiji" },
    { value: 62, label: "Filipinas" },
    { value: 63, label: "Finlandia" },
    { value: 64, label: "Francia" },
    { value: 65, label: "Gabón" },
    { value: 66, label: "Gambia" },
    { value: 67, label: "Georgia" },
    { value: 68, label: "Ghana" },
    { value: 69, label: "Granada" },
    { value: 70, label: "Grecia" },
    { value: 71, label: "Guatemala" },
    { value: 72, label: "Guinea" },
    { value: 73, label: "Guinea-Bissau" },
    { value: 74, label: "Guinea Ecuatorial" },
    { value: 75, label: "Guyana" },
    { value: 76, label: "Haití" },
    { value: 77, label: "Honduras" },
    { value: 78, label: "Hungría" },
    { value: 79, label: "India" },
    { value: 80, label: "Indonesia" },
    { value: 81, label: "Irán, República Islámica de" },
    { value: 82, label: "Iraq" },
    { value: 83, label: "Irlanda" },
    { value: 84, label: "Islandia" },
    { value: 85, label: "Islas Marshall" },
    { value: 86, label: "Islas Salomón" },
    { value: 87, label: "Israel" },
    { value: 88, label: "Italia" },
    { value: 89, label: "Jamahiriya Árabe Libia" },
    { value: 90, label: "Jamaica" },
    { value: 91, label: "Japón" },
    { value: 92, label: "Jordania" },
    { value: 93, label: "Kazajistán" },
    { value: 94, label: "Kenya" },
    { value: 95, label: "Kirguistán" },
    { value: 96, label: "Kiribati" },
    { value: 97, label: "Kuwait" },
    { value: 98, label: "Lesoto" },
    { value: 99, label: "Letonia" },
    { value: 100, label: "Líbano" },
    { value: 101, label: "Liberia" },
    { value: 102, label: "Liechtenstein" },
    { value: 103, label: "Lituania" },
    { value: 104, label: "Luxemburgo" },
    { value: 105, label: "Madagascar" },
    { value: 106, label: "Malasia" },
    { value: 107, label: "Malaui" },
    { value: 108, label: "Maldivas" },
    { value: 109, label: "Malí" },
    { value: 110, label: "Malta" },
    { value: 111, label: "Marruecos" },
    { value: 112, label: "Mauricio" },
    { value: 113, label: "Mauritania" },
    { value: 114, label: "México" },
    { value: 115, label: "Micronesia, Estados Federados de" },
    { value: 116, label: "Mónaco" },
    { value: 117, label: "Montenegro" },
    { value: 118, label: "Mongolia" },
    { value: 119, label: "Mozambique" },
    { value: 120, label: "Birmania" },
    { value: 121, label: "Namibia" },
    { value: 122, label: "Nauru" },
    { value: 123, label: "Nepal" },
    { value: 124, label: "Nicaragua" },
    { value: 125, label: "Níger" },
    { value: 126, label: "Nigeria" },
    { value: 127, label: "Noruega" },
    { value: 128, label: "Nueva Zelanda" },
    { value: 129, label: "Omán" },
    { value: 130, label: "Países Bajos" },
    { value: 131, label: "Pakistán" },
    { value: 132, label: "Palaos" },
    { value: 133, label: "Panamá" },
    { value: 134, label: "Papúa Nueva Guinea" },
    { value: 135, label: "Paraguay" },
    { value: 136, label: "Perú" },
    { value: 137, label: "Polonia" },
    { value: 138, label: "Portugal" },
    { value: 139, label: "Qatar" },
    { value: 140, label: "Reino Unido de Gran Bretaña e Irlanda del Norte" },
    { value: 141, label: "República Árabe Siria" },
    { value: 142, label: "República Centroafricana" },
    { value: 143, label: "República Checa" },
    { value: 144, label: "República de Corea" },
    { value: 145, label: "República Democrática del Congo" },
    { value: 146, label: "República Democrática Popular Lao" },
    { value: 147, label: "República Dominicana" },
    { value: 148, label: "República de Moldova" },
    { value: 149, label: "República Popular Democrática de Corea" },
    { value: 150, label: "República Unida de Tanzania" },
    { value: 151, label: "Rumania" },
    { value: 152, label: "Ruanda" },
    { value: 153, label: "Saint Kitts y Nevis" },
    { value: 154, label: "Samoa" },
    { value: 155, label: "San Marino" },
    { value: 156, label: "Santa Lucía" },
    { value: 157, label: "Santo Tomé y Príncipe" },
    { value: 158, label: "San Vicente y las Granadinas" },
    { value: 159, label: "Senegal" },
    { value: 160, label: "Serbia" },
    { value: 161, label: "Seychelles" },
    { value: 162, label: "Sierra Leona" },
    { value: 163, label: "Singapur" },
    { value: 164, label: "Somalia" },
    { value: 165, label: "Sri Lanka" },
    { value: 166, label: "Sudáfrica" },
    { value: 167, label: "Sudán" },
    { value: 168, label: "Suecia" },
    { value: 169, label: "Suiza" },
    { value: 170, label: "Surinam" },
    { value: 171, label: "Suazilandia" },
    { value: 172, label: "Tailandia" },
    { value: 173, label: "Tayikistán" },
    { value: 174, label: "Timor-Leste" },
    { value: 175, label: "Togo" },
    { value: 176, label: "Tonga" },
    { value: 177, label: "Trinidad y Tobago" },
    { value: 178, label: "Túnez" },
    { value: 179, label: "Turkmenistán" },
    { value: 180, label: "Turquía" },
    { value: 181, label: "Tuvalu" },
    { value: 182, label: "Ucrania" },
    { value: 183, label: "Uganda" },
    { value: 184, label: "Uruguay" },
    { value: 185, label: "Uzbekistán" },
    { value: 186, label: "Vanuatu" },
    { value: 187, label: "Venezuela, República Bolivariana de" },
    { value: 188, label: "Viet Nam" },
    { value: 189, label: "Yemen" },
    { value: 190, label: "Yibuti" },
    { value: 191, label: "Zambia" },
    { value: 192, label: "Zimbabwe" },
  ]

  const estadosCiviles = [
    { value: 1, label: "Soltero" },
    { value: 2, label: "Casado" },
    { value: 3, label: "Divorciado" },
    { value: 4, label: "Union Libre" },
    { value: 5, label: "Viudo" },
  ]
  // #endregion

  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region Internal States

  const [dataImage, setDataImage] = useState("")
  const [dataCropImage, setDataCropImage] = useState("")
  const [showWebcam, setShowWebcam] = useState(false)
  const [showCropComponent, setShowCropComponent] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [showDropZone, setShowDropZone] = useState(false)
  const [userImageUrl, setUserImageUrl] = useState(
    "https://avatar.iran.liara.run/public"
  )
  const [show, setShow] = useState(false)
  const [edad, setEdad] = useState("")
  // #endregion

  // #region useEffects

  //   useEffect(() => {
  //     console.log('isLoadingEmail', isLoadingEmail)
  //     console.log('email', email)
  //   if (!isLoadingEmail && email.length > 0) {
  //     console.log('Entró')
  //     console.log('formik.values.Email_Personal', formik.values.Email_Personal)
  //     if(email == formik.values.Email_Personal) {
  //     console.log('Entró al error')
  //       formik.setFieldError("Email_Personal", "Email repetido!")
  //     }
  //   }
  // }, [isLoadingEmail, email])

  //   useEffect(() => {
  //     console.log('isLoadingCurp', isLoadingCurp)
  //     console.log('curp', curp)
  //   if (!isLoadingCurp && curp.length > 0) {
  //     console.log('Entró')
  //     console.log('formik.values.Curp', formik.values.Curp)
  //     if(curp == formik.values.Curp) {
  //     console.log('Entró al error')
  //       formik.setFieldError("Curp", "Curp repetido!")
  //     }
  //   }
  // }, [isLoadingCurp, curp])

  //   // error
  //   useEffect(() => {
  //     if (error && error.length) {
  //       toast.error(error, {
  //         autoClose: 2000,
  //       })
  //       dispatch(ControlEscolarUnsetError())
  //     }
  //   }, [error])

  //   // error
  //   useEffect(() => {
  //     console.log(edad)
  //   }, [edad])

  // #endregion

  // #region functions

  const fnRecibirCropImage = base64Image => {
    console.log(base64Image)
    setDataCropImage(base64Image)
    toggleCropComponentVisibility()()
  }

  const receiveBase64 = (base64Image, control) => {
    console.log(control)
    setDataImage(base64Image)
    if (control === "webcam") {
      toggleWebcamVisibility()
    } else {
      toggleDropZoneVisibility()
    }
    toggleCropComponentVisibility()
  }

  const toggleDropZoneVisibility = () => {
    setShowDropZone(!showDropZone)
  }

  const toggleCropComponentVisibility = () => {
    setShowCropComponent(!showCropComponent)
  }

  const toggleWebcamVisibility = () => {
    setShowWebcam(!showWebcam)
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const handleDropAccepted = ({ formData, base64Files, identificator }) => {
    receiveBase64(base64Files[0], "dropcomponent")
  }

  const handleBlurEmail = event => {
    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const email = event.target.value

    console.log(formik)

    // Solo envía la petición si no hay errores
    if (!formik.errors.hasOwnProperty("Email_Personal")) {
      dispatch(
        getControlEscolarGetEmail({
          nombreSolicitud: "buscaemail",
          email: formik.values.Email_Personal,
        })
      )
    }

    // Re-envia el evento
    formik.handleBlur(event)
  }

  const handleBlurCurp = event => {
    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const curp = event.target.value

    console.log(formik)

    // Solo envía la petición si no hay errores
    if (!formik.errors.hasOwnProperty("Curp")) {
      dispatch(
        getControlEscolarGetCurp({
          nombreSolicitud: "buscacurp",
          curp: formik.values.Curp,
        })
      )

      formik.setFieldValue("id_Estado", obtenerIdEstado(curp))
      formik.setFieldValue("Sexo", obtenerGeneroPorCURP(curp))
      formik.setFieldValue(
        "Fecha_Nacimiento",
        obtenerFechaNacimientoPorCURP(curp)
      )
      formik.setFieldValue("Password", generarPassword())
      calcularEdad(obtenerFechaNacimientoPorCURP(curp))
    }

    // Re-envia el evento
    formik.handleBlur(event)
  }

  function generarPassword() {
    const longitud = 6 // Puedes ajustar la longitud del password aquí
    const caracteres =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    let password = ""

    // Garantizar que el password tenga al menos una letra minúscula, una mayúscula y un número
    const minLower = "abcdefghijklmnopqrstuvwxyz"
    const minUpper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    const minNum = "0123456789"

    // Añadir un carácter obligatorio de cada tipo
    password += minLower.charAt(Math.floor(Math.random() * minLower.length))
    password += minUpper.charAt(Math.floor(Math.random() * minUpper.length))
    password += minNum.charAt(Math.floor(Math.random() * minNum.length))

    // Llenar el resto del password con caracteres aleatorios hasta alcanzar la longitud deseada
    for (let i = password.length; i < longitud; i++) {
      password += caracteres.charAt(
        Math.floor(Math.random() * caracteres.length)
      )
    }

    // Mezclar el password para que los caracteres obligatorios no estén solo al principio
    password = password
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("")

    return password
  }

  const calcularEdad = fechaNacimiento => {
    const hoy = new Date()
    const nacimiento = new Date(fechaNacimiento)
    let edad = hoy.getFullYear() - nacimiento.getFullYear()
    let mes = hoy.getMonth() - nacimiento.getMonth()
    let dia = hoy.getDate() - nacimiento.getDate()

    if (mes < 0 || (mes === 0 && dia < 0)) {
      edad-- // Si no ha llegado el mes de su cumpleaños este año, restar un año a la edad
      mes += 12 // Compensar el mes negativo sumando 12
    }

    if (dia < 0) {
      mes-- // Ajustar los meses si los días son negativos
      // Calcular los días restantes ajustando según el mes anterior
      const diasDelMesAnterior = new Date(
        hoy.getFullYear(),
        hoy.getMonth(),
        0
      ).getDate()
      dia += diasDelMesAnterior
    }

    //setEdad(`${edad} años, ${mes} meses y ${dia} días`);
    setEdad(`${edad} años, ${mes} meses`)
  }

  function obtenerIdEstado(curp) {
    const estadoMap = {
      AS: 1,
      BC: 2,
      BS: 3,
      CC: 4,
      CS: 5,
      CH: 6,
      CL: 7,
      CM: 8,
      DF: 9,
      DG: 10,
      GR: 11,
      GT: 12,
      HG: 13,
      JC: 14,
      MC: 15,
      MN: 16,
      MS: 17,
      NT: 18,
      NL: 19,
      OC: 20,
      PL: 21,
      QT: 22,
      QR: 23,
      SP: 24,
      SL: 25,
      SR: 26,
      TC: 27,
      TS: 28,
      TL: 29,
      VZ: 30,
      YN: 31,
      ZS: 32,
      XX: -1,
    }

    // Extracción de las letras que indican el estado del CURP
    const estadoCurp = curp.slice(11, 13).toUpperCase()

    // Obtener el id del estado basado en las letras del CURP
    const idEstado =
      estadoMap[estadoCurp] !== undefined ? estadoMap[estadoCurp] : -1

    return idEstado
  }

  function obtenerGeneroPorCURP(curp) {
    // El carácter en la posición 10 del CURP indica el género: 'H' para hombre, 'M' para mujer
    const genero = curp.charAt(10).toUpperCase()

    if (genero === "H") {
      return 1 // Hombre
    } else if (genero === "M") {
      return 0 // Mujer
    } else {
      return -1 // Indica que el CURP no tiene un formato correcto para el género
    }
  }

  function obtenerFechaNacimientoPorCURP(curp) {
    // Extracción de la fecha de nacimiento del CURP (posiciones 4 a 9)
    // Año (2 dígitos), mes (2 dígitos), día (2 dígitos)
    const anio = curp.slice(4, 6)
    const mes = curp.slice(6, 8)
    const dia = curp.slice(8, 10)

    // Determinar el siglo completo del año
    const anioCompleto =
      parseInt(anio) +
      (parseInt(anio) >= 0 && parseInt(anio) <= 22 ? 2000 : 1900)

    // Creación de la fecha
    const fechaNacimiento = new Date(`${anioCompleto}-${mes}-${dia}`)

    if (isNaN(fechaNacimiento)) {
      return "Fecha no válida" // En caso de que los datos no formen una fecha válida
    }

    return fechaNacimiento.toISOString().substring(0, 10) // Retorna la fecha en formato YYYY-MM-DD
  }

  // #endregion

  //#region Formik form

  const onSubmit = values => {
    // //console.log("Form data", values)
    // dispatch(
    //   onPutControlEscolarPutPersona({
    //     nombreSolicitud: "updatepersona",
    //     oPersona: values,
    //     idAlumno: idAlumno,
    //     idPersona: idPersonaAuthenticated,
    //   })
    // )
  }

  // const formik = useFormik({
  //   initialValues: initialValues,
  //   validationSchema: validationSchema,
  //   onSubmit: onSubmit,
  //   enableReinitialize: true,
  // })

  // #endregion

  return (
    <React.Fragment>
      {/* {//console.log("formik.touched: ", formik.touched)}
      {//console.log("formik.errors: ", formik.errors)}
      {//console.log("formik.isValid: ", formik.isValid)}
      {//console.log("isAdministradorGeneral: ", isAdministradorGeneral)} */}
      <ImageCropComponent
        isVisible={showCropComponent}
        base64={dataImage}
        fnRecibirCropImage={fnRecibirCropImage}
      />
      <ToastContainer />
      <DropzoneComponent
        onDropAccepted={handleDropAccepted}
        isOpen={showDropZone}
        maxFiles={1}
      />
      <Form onSubmit={formik.handleSubmit}>
        <Row>
          <div id="liveAlertPlaceholder">
            <UncontrolledAlert
              color="danger"
              role="alert"
              isOpen={show}
              toggle={() => {
                setShow(false)
              }}
            >
              A simple danger alert—check it out!
            </UncontrolledAlert>
          </div>
        </Row>
        {/* 1er Row Apellido_Paterno && Curp */}
        {/* Foto */}
        <Row>
          <Col md={10}>
            {/* Apellido_Paterno, Apellido_Materno, Nombres */}
            <Row>
              <Col md={4}>
                {" "}
                <div className="mb-3">
                  <Label htmlFor="formrow-Apellido_Paterno-Input">
                    * Apellido Paterno
                  </Label>
                  {!isLoading ? (
                    <Input
                      type="text"
                      name="Apellido_Paterno"
                      className="form-control"
                      id="formrow-Apellido_Paterno-Input"
                      placeholder="Apellido Paterno"
                      autoComplete="off"
                      value={formik.values.Apellido_Paterno}
                      onChange={handleUpperCaseChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.Apellido_Paterno &&
                        formik.errors.Apellido_Paterno
                          ? true
                          : false
                      }
                    />
                  ) : (
                    <div>
                      <p aria-hidden="true" className="mt-2">
                        <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                      </p>
                    </div>
                  )}
                  {formik.errors.Apellido_Paterno &&
                  formik.touched.Apellido_Paterno ? (
                    <FormFeedback type="invalid">
                      {formik.errors.Apellido_Paterno}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col md={4}>
                {" "}
                <div className="mb-3">
                  <Label htmlFor="formrow-Apellido_Materno-Input">
                    * Apellido Materno
                  </Label>
                  {!isLoading ? (
                    <Input
                      type="text"
                      name="Apellido_Materno"
                      className="form-control"
                      id="formrow-Apellido_Materno-Input"
                      placeholder="Apellido Materno"
                      autoComplete="off"
                      value={formik.values.Apellido_Materno}
                      onChange={handleUpperCaseChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.Apellido_Materno &&
                        formik.errors.Apellido_Materno
                          ? true
                          : false
                      }
                    />
                  ) : (
                    <div>
                      <p aria-hidden="true" className="mt-2">
                        <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                      </p>
                    </div>
                  )}

                  {formik.errors.Apellido_Materno &&
                  formik.touched.Apellido_Materno ? (
                    <FormFeedback type="invalid">
                      {formik.errors.Apellido_Materno}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col md={4}>
                {" "}
                <div className="mb-3">
                  <Label htmlFor="formrow-Nombres-Input">* Nombre(s)</Label>
                  {!isLoading ? (
                    <Input
                      type="text"
                      name="Nombres"
                      className="form-control"
                      id="formrow-Nombres-Input"
                      placeholder="Nombre de pila"
                      autoComplete="off"
                      value={formik.values.Nombres}
                      onChange={handleUpperCaseChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.Nombres && formik.errors.Nombres
                          ? true
                          : false
                      }
                    />
                  ) : (
                    <div>
                      <p aria-hidden="true" className="mt-2">
                        <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                      </p>
                    </div>
                  )}

                  {formik.errors.Nombres && formik.touched.Nombres ? (
                    <FormFeedback type="invalid">
                      {formik.errors.Nombres}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>
            {/* Curp, Email, Password */}
            <Row>
              <Col md={4}>
                {" "}
                <div className="mb-3">
                  <Label htmlFor="formrow-Curp-Input">* CURP</Label>
                  {!isLoading ? (
                    <Input
                      type="text"
                      name="Curp"
                      className="form-control"
                      id="formrow-Curp-Input"
                      placeholder="Curp"
                      value={formik.values.Curp}
                      onChange={handleUpperCaseChange}
                      onBlur={handleBlurCurp}
                      invalid={
                        formik.touched.Curp && formik.errors.Curp ? true : false
                      }
                    />
                  ) : (
                    <div>
                      <p aria-hidden="true" className="mt-2">
                        <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                      </p>
                    </div>
                  )}

                  {formik.errors.Curp && formik.touched.Curp ? (
                    <FormFeedback type="invalid">
                      {formik.errors.Curp}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="formrow-Email_Personal-Input">* Email</Label>
                  {!isLoading ? (
                    <Input
                      type="email"
                      name="Email_Personal"
                      className="form-control"
                      id="formrow-Email_Personal-Input"
                      placeholder="Escribe el email personal"
                      autoComplete="off"
                      value={formik.values.Email_Personal}
                      onChange={handleLowerCaseChange}
                      onBlur={handleBlurEmail}
                      invalid={
                        formik.touched.Email_Personal &&
                        formik.errors.Email_Personal
                          ? true
                          : false
                      }
                    />
                  ) : (
                    <div>
                      <p aria-hidden="true" className="mt-2">
                        <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                      </p>
                    </div>
                  )}

                  {formik.errors.Email_Personal &&
                  formik.touched.Email_Personal ? (
                    <FormFeedback type="invalid">
                      {formik.errors.Email_Personal}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="formrow-Password-Input">* Password</Label>

                  {!isLoading ? (
                    <>
                      <div className="input-group">
                        <Input
                          type={showPassword ? "text" : "password"}
                          name="Password"
                          className="form-control"
                          id="formrow-Password-Input"
                          placeholder="Escribe el password"
                          autoComplete="off"
                          value={formik.values.Password}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.Password && formik.errors.Password
                              ? true
                              : false
                          }
                        />{" "}
                        <div
                          className="input-group-text"
                          style={{ cursor: "pointer" }}
                          onClick={togglePasswordVisibility}
                        >
                          <i
                            className={`fas ${
                              showPassword ? "fa-eye" : "fa-eye-slash"
                            }`}
                          ></i>
                        </div>
                        {formik.errors.Password && formik.touched.Password ? (
                          <FormFeedback type="invalid">
                            {formik.errors.Password}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </>
                  ) : (
                    <p aria-hidden="true" className="mt-2">
                      <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                    </p>
                  )}
                </div>
              </Col>
            </Row>
          </Col>

          {/* Foto */}
          <Col md={2}>
            {" "}
            <div className="text-center">
              {showWebcam ? (
                <Webcam
                  isOpen={showWebcam}
                  onClose={toggleWebcamVisibility}
                  recibe={receiveBase64}
                  size={{ width: 1024, height: 768 }}
                />
              ) : (
                <img
                  src={dataCropImage ? dataCropImage : userImageUrl}
                  width={341}
                  alt=""
                  className="avatar-xl rounded d-block mx-auto" //className="avatar-xxl rounded position-relative z-n1"
                />
              )}
              <Row className="icon-demo-content">
                {!showWebcam && !showCropComponent && (
                  <>
                    <Col>
                      <Link onClick={toggleWebcamVisibility}>
                        <i className="bx bx-camera icon-hover-effect me-2"></i>
                      </Link>
                    </Col>
                    <Col>
                      <Link onClick={toggleDropZoneVisibility}>
                        <i className="bx bx-cloud-upload icon-hover-effect me-2"></i>
                      </Link>
                    </Col>
                  </>
                )}
              </Row>
              {/* <i className="bx bxs-file-jpg"></i> */}
            </div>
          </Col>
        </Row>

        {/* Género, Telefono Celular, Estado Civil */}
        <Row>
          <Col md={3}>
            <div className="mb-3">
              <Label className="d-block mb-3">* Género </Label>
              {!isLoading ? (
                <>
                  <div className="form-check form-check-inline">
                    <Input
                      type="radio"
                      id="customRadioInline1"
                      className="form-check-input"
                      name="Sexo"
                      value="Masculino"
                      checked={formik.values.Sexo === 1}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="customRadioInline1"
                    >
                      Masculino
                    </label>
                  </div>
                  &nbsp;
                  <div className="form-check form-check-inline">
                    <Input
                      type="radio"
                      className="form-check-input"
                      id="customRadioInline2"
                      name="Sexo"
                      value="Femenino"
                      checked={formik.values.Sexo === 0}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="customRadioInline2"
                    >
                      Femenino
                    </label>
                  </div>
                  <div>
                    {formik.errors.Sexo && formik.touched.Sexo ? (
                      <FormFeedback type="invalid">
                        {formik.errors.Sexo}
                      </FormFeedback>
                    ) : null}
                  </div>
                </>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
            </div>
          </Col>
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Telefono_Celular-Input">
                * Telefono Celular
              </Label>
              {!isLoading ? (
                <InputMask
                  mask="(99) 99-99-99-99"
                  type="text"
                  name="Telefono_Celular"
                  className="form-control"
                  id="formrow-Telefono_Celular-Input"
                  placeholder="Número de celular"
                  autoComplete="off"
                  value={formik.values.Telefono_Celular}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Telefono_Celular &&
                    formik.errors.Telefono_Celular
                      ? true
                      : false
                  }
                />
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}

              {formik.errors.Telefono_Celular &&
              formik.touched.Telefono_Celular ? (
                <FormFeedback type="invalid">
                  {formik.errors.Telefono_Celular}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-InputEstado_Civil">Estado Civil</Label>
              {!isLoading ? (
                <select
                  name="id_Estado_Civil"
                  id="formrow-InputEstado_Civil"
                  className="form-control form-select"
                  value={formik.values.id_Estado_Civil}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {estadosCiviles.map(option => {
                    return (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Estado_Civil &&
              formik.touched.id_Estado_Civil ? (
                <span className="text-danger">
                  {formik.errors.id_Estado_Civil}
                </span>
              ) : null}
            </div>
          </Col>
        </Row>

        {/* Ciudad Nacimiento, Estado, Pais */}
        <Row>
          <Col lg={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-InputCity">Ciudad de Nacimiento</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="city"
                  className="form-control"
                  id="formrow-InputCity"
                  placeholder="Ciudad de nacimiento"
                  autoComplete="off"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.city && formik.errors.city ? true : false
                  }
                />
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}

              {formik.errors.city && formik.touched.city ? (
                <FormFeedback type="invalid">{formik.errors.city}</FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col lg={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-InputEstado">* Estado Nacimiento</Label>
              {!isLoading ? (
                <select
                  name="id_Estado"
                  id="formrow-InputEstado"
                  className="form-control form-select"
                  value={formik.values.id_Estado}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {estadosOptions.map(option => {
                    return (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Estado && formik.touched.id_Estado ? (
                <span className="text-danger">{formik.errors.id_Estado}</span>
              ) : null}
            </div>
          </Col>

          <Col lg={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-id_Pais">* País de Nacimiento</Label>
              {!isLoading ? (
                <select
                  name="id_Pais"
                  id="formrow-InputState"
                  className="form-control form-select"
                  value={formik.values.id_Pais}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {paisesOptions.map(option => {
                    return (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.id_Pais && formik.touched.id_Pais ? (
                <FormFeedback type="invalid">
                  {formik.errors.id_Pais}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>

        {/* Fecha Nacimiento */}
        <Row>
          <Col lg={4}>
            <div className="mb-3">
              <Label htmlFor="formrow-Fecha_Nacimiento">
                * Fecha de Nacimiento {edad ? `(${edad})` : null}
              </Label>
              {!isLoading ? (
                <InputGroup>
                  <Flatpickr
                    ref={flatpickrRef}
                    options={optionsFlatpickr}
                    name="formrow-Fecha_Nacimiento"
                    className="form-control d-block"
                    id="formrow-Fecha_Nacimiento"
                    placeholder="Fecha de nacimiento"
                    value={formik.values.Fecha_Nacimiento}
                    onChange={(selectedDates, dateStr, instance) => {
                      formik.setFieldValue("Fecha_Nacimiento", dateStr)
                      calcularEdad(dateStr)
                    }}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.Fecha_Nacimiento &&
                      formik.errors.Fecha_Nacimiento
                        ? true
                        : false
                    }
                  />
                  <div
                    className="input-group-text"
                    style={{ cursor: "pointer" }}
                  >
                    <i className={`bx bx-calendar`}></i>
                  </div>
                </InputGroup>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.Fecha_Nacimiento &&
              formik.touched.Fecha_Nacimiento ? (
                <FormFeedback type="invalid">
                  {formik.errors.Fecha_Nacimiento}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  )
}

export default AltaGenerales
